//

import $ from 'jquery';
import config from './../../../../config';

export function get_meetings_reports(  start_date, end_date, user ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'hr-reports/',
			data: {
				method	: 'GET_MEETING_REPORTS',
				start_date: start_date, 
				end_date: end_date,
				user: user,
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "GET_MEETING_REPORTS",
				hr_meetings	: response
			})
		})

	}
}

export function update_meetins_fields( id, key, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'hr-reports/',
			data: {
				method	: 'UPDATE_MEETING_FIELDS',
				id: id,
				key: key,
				value: value
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "UPDATE_MEETING_FIELDS",
				hr_meetings	: response
			})
		})

	}
}

export function get_initial_users(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'hr-reports/',
			data: {
				method	: 'GET_INITIAL_USERS',
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "GET_INITIAL_USERS",
				hr_meetings	: response
			})
		})

	}
}



export function delete_meeting( id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'hr-reports/',
			data: {
				method	: 'HR_DELETE_MEETING',
				meeting_id: id
            }
		})
		.then(function (response) {
			dispatch({
				type 	: "HR_DELETE_MEETING",
				hr_meetings	: response
			})
		})

	}
}


// WEBPACK FOOTER //
// ./src/pages/hr-reports/meetings/actions/meetings.action.js